import { render, staticRenderFns } from "./TextAreaEditStyle.vue?vue&type=template&id=6200f9b8&"
import script from "./TextAreaEditStyle.vue?vue&type=script&lang=js&"
export * from "./TextAreaEditStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports